module.exports = __webpack_public_path__ + "media/images/flags/4x3/rou-028cf08fb957a6d9c64d7d11a05093ca.svg";